import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Droplets, Activity } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-20 px-4 bg-primary text-white relative overflow-hidden" data-id="element-87">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-88">
        <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="absolute w-full h-full" data-id="element-89">
          <path d="M0,0 C30,40 70,60 100,0 L100,100 L0,100 Z" fill="currentColor" data-id="element-90" />
        </svg>
      </div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-92">
          <h2 className="font-heading text-3xl md:text-5xl mb-6" data-id="element-93">
            La solución no es comer menos, <br data-id="element-94" />
            <span className="text-accent" data-id="element-95">es "apagar" la señal de alarma.</span>
          </h2>
          <p className="text-lg md:text-xl text-sage/90 mb-12 max-w-2xl mx-auto" data-id="element-96">
            Presentamos el{' '}
            <strong className="text-white" data-id="element-97">
              Mecanismo de Desactivación por Especias (MDE)
            </strong>
            .
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-left" data-id="element-98">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl border border-white/20" data-id="element-99">
            <Sparkles className="w-10 h-10 text-accent mb-4" data-id="element-100" />
            <h3 className="font-heading text-xl mb-3" data-id="element-101">Sabiduría + Ciencia</h3>
            <p className="text-sage/80 text-sm leading-relaxed" data-id="element-102">
              Utiliza la sabiduría de la cocina latina combinada con ciencia
              moderna para resetear tu sistema nervioso usando 5 especias
              estratégicas que ya tienes en tu alacena.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl border border-white/20" data-id="element-103">
            <Activity className="w-10 h-10 text-accent mb-4" data-id="element-104" />
            <h3 className="font-heading text-xl mb-3" data-id="element-105">Señal de Calma</h3>
            <p className="text-sage/80 text-sm leading-relaxed" data-id="element-106">
              Le daremos a tu cuerpo la señal exacta de que "está a salvo",
              reduciendo drásticamente los niveles de cortisol que te mantienen
              inflamada.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl border border-white/20" data-id="element-107">
            <Droplets className="w-10 h-10 text-accent mb-4" data-id="element-108" />
            <h3 className="font-heading text-xl mb-3" data-id="element-109">Resultados en 48h</h3>
            <p className="text-sage/80 text-sm leading-relaxed" data-id="element-110">
              En solo 48 horas, tus riñones empezarán a drenar el exceso de
              líquido retenido y tu digestión se acelerará por primera vez en
              meses.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}